/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<22a3dca603f392d581ca9683a44603f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObject_HelpCenterHelpObject$data = {
  readonly __typename: "HelpObjectStoreArticle";
  readonly entityKey: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectArticle_HelpObjectStoreArticle">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  readonly __typename: "HelpObjectStoreChannel";
  readonly entityKey: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectChannel_HelpObjectStoreChannel">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  readonly __typename: "HelpObjectStoreRequestForm";
  readonly entityKey: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectRequestForm_HelpObjectStoreRequestForm">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
};
export type helpObject_HelpCenterHelpObject$key = {
  readonly " $data"?: helpObject_HelpCenterHelpObject$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObject_HelpCenterHelpObject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityKey",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "helpObject_HelpCenterHelpObject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "helpObjectRequestForm_HelpObjectStoreRequestForm"
        },
        (v0/*: any*/)
      ],
      "type": "HelpObjectStoreRequestForm",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "helpObjectArticle_HelpObjectStoreArticle"
        },
        (v0/*: any*/)
      ],
      "type": "HelpObjectStoreArticle",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "helpObjectChannel_HelpObjectStoreChannel"
        },
        (v0/*: any*/)
      ],
      "type": "HelpObjectStoreChannel",
      "abstractKey": null
    }
  ],
  "type": "HelpCenterHelpObject",
  "abstractKey": "__isHelpCenterHelpObject"
};
})();

(node as any).hash = "5d1a77d1436aff117f51a7fd98a43acf";

export default node;
